import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const TaskTypeStyles: moduleStyleType = {
    reviewIcon: {
        color: palette.brand.main,
    },
    grantIcon: {
        color: palette.success.main,
    },
    emergencyAccessIcon: {
        color: palette.warning.main,
    },
    revokeIcon: {
        color: palette.error.main,
    },
    actionIcon: {
        color: '#A4198D',
    },
    extensionGrantIcon: {
        color: palette.warning.dark,
    },
}
